
import React from 'react';
import Navbar from './Navbar';
import WhoIAm from './WhoIAm';
import Footer from './Footer';
import Cardskills from './Cardskills';




const Skills = () => {

  return (
    <div>
          <Navbar />
          <WhoIAm />
          <Cardskills />
          <Footer />
    </div>
  );
};

export default Skills;
